export default __webpack_public_path__ + "static/media/keycloak-bg.b232361f.png";